import { Inject, Injectable } from '@angular/core';
import {  HttpClient } from '@angular/common/http';
import { catchError, map} from 'rxjs/operators';
import {
  throwError,
} from 'rxjs';
import {
  TechLibPortalConfig,
  TECH_LIB_PORTAL_CONFIG,
} from '../../../tech-lib-portal.interceptor';
import { PublicPlannerEnum } from '../../../services/api-names';
import { modelportfolioThemesServiceEnum } from '../../../services/api-names';
import { Utils } from '../../../utils/utils';
import { FeeInterface } from '../../financialplanning/request/interfaces/fee.interface';
import { ModelPortfolioGroupInterface } from '../response/interfaces/modelportfoliogroup.interface';
import { ModelPortfoliosInterface } from '../response/interfaces/modelportfolios.interface';

@Injectable({
  providedIn: 'root',
})
export class ModelportfoliothemesService {

  constructor(
    @Inject(TECH_LIB_PORTAL_CONFIG) private config: TechLibPortalConfig,
    private http: HttpClient,
  ) {}

  public getMPThemes() {
    let url = this.config.baseApi + modelportfolioThemesServiceEnum.apirest_modelportfolio_groups;
    return this.http.get<[ModelPortfolioGroupInterface]>(url).pipe(
      map((res) => {
        return res;
      }),
      catchError((err) => {
        return throwError(err);
      })
    );
  }

  public getModelPortfoliosGroup(groupCode: string) {
    let url = Utils.formatString(
      this.config.baseApi + modelportfolioThemesServiceEnum.apirest_modelportfolio_group,
      [groupCode]
    );
    return this.http.get<ModelPortfoliosInterface>(url).pipe(
      map((res) => {
        return res;
      }),
      catchError((err) => {
        return throwError(err);
      })
    );
  }

}
